import React, {useLayoutEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import TableFunction from '../../../../../components/table/TableFunction';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import { permissionObj } from '../../../../../Helpers/permission';
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';
import { getTextNoInfoByKey } from '../Model/Models';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import NotInformation from '../../../../../components/NotInformation';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AttendingUsersTableApp = (
    {
        optionTable,
        results,
        setResults,
        searchElement,
        userTypeIds = [],
        setShowCreateNewVisitorModal
    }
) => {
    const dispatch = useDispatch();

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [visitorSelected, setVisitorSelected] = useState(null);
    const elementRef = useRef(null);

    useLayoutEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 100;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, [results?.content]);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, key: searchElement, model: optionTable, userTypeIds });
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    };
    /**
     * Handle to build table
     */
    const { t, pagination, rowsPerPage } = TableFunction({
        data: results,
        labelRowsPerPage: 'users_per_page',
        hasContainer: true,
        fixedPagination: false,
        searchElement, //New
        getData,//New
    });

    /**
     * Obtains the NoInformation component based on the selected user type
     * @param userType
     * @returns {JSX.Element}
     */
    const getChildrenNoInformation = (userType) => {
        if (parseInt(userType) === USER_TYPE_MODEL.VISITOR && results?.content?.length === 0 && searchElement !== "") {
            return <NotInformation card={true}>
                <div className={"warning-text"}>
                    <p>{t("you_haven_not_created_any_visitor")}</p>
                </div>
                {(DEV || permission?.includes(permissionObj?.WEB_EVENT_CREATE)) &&
                    <CustomButtonLink splitName={false} id={'btn_auta_create_visitor'} card={true}
                        onClick={() => {
                            setVisitorSelected(null);
                            setShowCreateNewVisitorModal(true);
                        }}
                        name={'create_a_new_visitor'} />
                } </NotInformation>
        } else {
            return <NotInformation text={t(getTextNoInfoByKey(userType) || EMPTY_VALUES.DEFAULT)} className={"h-100"} card={true} />
        }
    }

    return {
        t,
        pagination,
        rowsPerPage,
        getData,
        visitorSelected,
        setVisitorSelected,
        getChildrenNoInformation,
        elementRef
    };

}

export default AttendingUsersTableApp;
